// Zentrale Einstellungen – Standardwerte. Im Admin-Bereich (/admin) überschreibbar.
export const SITE_DEFAULTS = {
  brand_name: 'Bican Coskun', // BRAND_NAME
  brand_initials: 'BC', // BRAND_INITIALS
  next_start: 'November', // NEXT_START
  slots_total: 5, // SLOTS_TOTAL
  slots_free: 3, // SLOTS_FREE
  slots_auto: true, // true = Start-Monat und freie Plätze rechnen sich automatisch pro Woche
  price: 497, // PRICE
  checklist_url:
    'https://2e3bd8ce.sibforms.com/serve/MUIFANtC1skNnZYLBje8vpDtlFaiQ8VEY78afwDuvTd3Cw5JiNHqKNMeGHmYeQE-nwAWna710Ocnm9uPH8KXlQUsEqmH2mvRd0CB17vcLuAJRc0YAk8vdfaPSFbl_FN2_46aGsk4z0a1spkDqRj1s8GinDsT09nVPtA4U3TEyQG7gAxGUuJ0RQjYIii6J1UTM06djfeFOYa1t3UY', // CHECKLIST_URL
  trustpilot_url: 'https://de.trustpilot.com/review/aktien-coskun.com', // TRUSTPILOT_URL
};

export const CONTACT_EMAIL = 'infobicancoskun@gmail.com';
export const IMPRESSUM_URL = 'https://www.mein.online-impressum.de/bican-cskn/';
export const VIDEO_ID = 'FuMuTLr0DsA';
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
